import { Block } from 'components/Block'
import { useLPActions } from 'components/actions/useLPActions'
import { ActionCards } from 'components/actions/ActionCards'
import { useTranslation } from 'next-i18next'

export function SingingPortraitsWizardCards() {
  const { t } = useTranslation('memory')
  const actions = useLPActions([
    'story_portraits',
    'live_portraits',
    'future_messages',
    'digital_vault',
    'will',
  ])

  return (
    <Block>
      <ActionCards
        variant="round-button"
        title={t('memory.singing.action_card_title')}
        actions={actions}
      />
    </Block>
  )
}
